import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import DashboardPage from './pages/DashboardPage';
import { BusinessSettingsProvider } from './context/BusinessSettingsContext';

export default function App() {
  return (
    <BusinessSettingsProvider>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/dashboard" element={<DashboardPage />} />
      </Routes>
    </BusinessSettingsProvider>
  );
}
